import React from 'react';
import { anyValues } from 'helpers/utility';
import TooltipMUI from '../TooltipMUI';
const TooltipMUIConditionalWrapper = ({ children, tooltipProps }) => anyValues(tooltipProps) ? React.createElement(TooltipMUI, { ...tooltipProps }, children) : React.createElement(React.Fragment, null, children);
export default TooltipMUIConditionalWrapper;
